import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class PatternValidationRule extends ValidationRule {
  private pattern: RegExp;

  constructor(pattern: RegExp, key: string | null = null) {
    super(key ?? ValidationTypes.pattern);
    this.pattern = pattern;
  }

  isValid(value: any): boolean {
    if (typeof value === 'string') {
      value = value.trim();
    }

    if (!value) {
      return true;
    }
    return this.pattern.test(value);
  }
}
